import { useLocation, Location, useNavigate } from 'react-router-dom';
import { Trans } from 'react-i18next';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import TopBar from '../../../componentsv2/TopBar';
import MarcoLogo from '../../../componentsv2/MarcoLogo';
import Typography from '../../../componentsv2/Typography';
import Button from '../../../componentsv2/Button';
import { InboxIcon } from '../../../components/Icons';
import { useLazyTranslation } from '../../../hooks/i18n';
import { COLORS } from '../../../themev2';

interface LocationState {
  state: { email: string };
}

const RegisterConfirmation = () => {
  const { t } = useLazyTranslation();
  const navigate = useNavigate();
  const location = useLocation() as Location & LocationState;

  if (!location?.state?.email) {
    navigate('/');
  }

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
      <TopBar>
        <Box sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <IconButton href="/">
            <MarcoLogo />
          </IconButton>
        </Box>
      </TopBar>
      <Box component="main" sx={{ flexGrow: 1, p: 8, backgroundColor: COLORS.gray[300] }}>
        <Container
          sx={{
            maxWidth: { xs: '100%', sm: 400, md: 550 },
            padding: '1em 0em',
          }}
        >
          <Grid container>
            <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <InboxIcon />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h4" textAlign={{ xs: 'center' }} fontWeight={700}>
                {t('register.title')}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                textAlign={{ xs: 'center' }}
                sx={{ fontSize: '18px', lineHeight: '27px', color: '#66758F' }}
              >
                <Trans t={t} i18nKey={'register.userEmailVerification'}>
                  <Typography sx={{ fontWeight: 600 }}>We sent you an email to:</Typography>
                  <Typography sx={{ marginLeft: '5px', fontWeight: 600 }}>
                    <p>{{ email: location?.state?.email }}</p>
                  </Typography>
                </Trans>
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: COLORS.gray[1100] }}>{t('register.description')}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: COLORS.gray[1100] }}>
                {`${t('register.contactSupport')} `}
                <a href={'mailto:' + t('register.supportEmail')}>{t('register.supportEmail')}</a>
                {` ${t('register.fillForm')} `}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://holamarco.co/contacto"
                style={{ textDecoration: 'none', display: 'flex', justifyContent: 'center' }}
              >
                <Button color="secondary">{t('register.contactUs')}</Button>
              </a>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default RegisterConfirmation;
